<template lang="pug">
  div
    accepting-orders-confirm-table(
      action_name="new"
      v-if="confirming"
      :acceptingOrder="acceptingOrder"
      :acceptingOrderItems="acceptingOrderItems"
      @confirming="confirm"
      )
    abstract-accepting-order-fields(
      action_name="new"
      draft_action_name="new"
      button_label="確認する"
      draft_button_label="下書き作成"
      @confirming="confirm"
      @onValid="setAcceptingOrder"
      v-show="!confirming"
    )
</template>

<script>
  import AbstractAcceptingOrderFields  from 'components/accepting_orders/abstract_accepting_order_fields'
  import AcceptingOrdersConfirmTable from 'components/accepting_orders/accepting_orders_confirm_table'

  export default {
    name: 'new-accepting-order-fields',
    components: { AbstractAcceptingOrderFields, AcceptingOrdersConfirmTable },
    data() {
      return {
        confirming: false,
        acceptingOrder: null,
        acceptingOrderItems: null
      }
    },
    methods: {
      confirm(confirming) {
        this.confirming = confirming
      },
      setAcceptingOrder(acceptingOrder, acceptingOrderItems) {
        this.acceptingOrder = acceptingOrder
        this.acceptingOrderItems = acceptingOrderItems
      },
   }
  }
</script>
